module.exports = __webpack_public_path__ + "img/top-notch-logo.22cec86e.png";